import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        login(data);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Login Google gagal. Coba lagi.";
        window.history.replaceState(null, "", "/login");
        nav("/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [location.hash, login, nav]);
  return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Memproses login...</div>;
}
